import { observable, computed, runInAction } from 'mobx';
import { get } from '../utils';

class findList {
    static PAGE_SIZE = 10;
    private params: any;
    private route: string;
    @observable public firstFetched: boolean = false;
    @observable public isEmpty: boolean = false;
    @observable public lists: any[] = [];
    @observable public banner: any;
    @observable public page: any = 1;
    @observable public isLoadOk: any = '';

    constructor(params: any) {
        this.route = params.url;
        this.params = params;
    }

    updateParams(key, val) {
        this.params[key] = val;
    }

    @observable
    private isLastPage: boolean = true;

    @computed
    get canFetch() {
        if (this.isEmpty) {
            return false;
        }
        return !this.isLastPage;
    }

    fetch(page, callback: any) {
        this.page = page;
        let obj = Object.assign({
            pageid: this.page
        }, this.params);
        get(this.route, obj).then((d) => {
            let data;
            data = d.data;
            if (!data) return false;
            callback && callback(data);
            runInAction(() => {
                if (this.page == 1) {
                    this.lists = [];
                    this.isEmpty = data.length == 0;
                }
                this.firstFetched = true;
                this.isLastPage = data.length < findList.PAGE_SIZE;
                let __isChooseAdd: any = sessionStorage.getItem('__isChooseAdd');
                let receiver = sessionStorage.getItem('__receiver');
                let __receiver: any = JSON.parse(receiver || '{}');
                data.forEach((item) => {
                    item.key = item.ciId + '' + Date.now();
                    if (receiver) {
                        if (item.address == __receiver.address && item.addressId == __receiver.addressUuid && item.contact == __receiver.receiverName && item.mobilephone == __receiver.receiverMobile) {
                            item.isChoose = true;
                        }
                    } else {
                        item.isChoose = __isChooseAdd == item.addressId;
                    }
                    this.lists.push(item);
                });
            });
        });
    }

    @computed
    get list() {
        return this.lists.slice();
    }
}

export default findList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/FindList.ts